import type { RunSummary } from "contracts/api/crawl/run-read.responses";
import type { OverviewResponse } from "contracts/api/dashboard/responses";
import { Show } from "solid-js";
import { spacedKey } from "../../boundaries/label.formatter";
import { relativeAge } from "../../ui/format";
import { scanCoverage, scanCoverageLine } from "./scanCoverage";
import { contentFitnessHeadline } from "./scanModel";

export function ContentFitnessProvenance(props: {
  data: OverviewResponse;
  completedRun: RunSummary | null;
}) {
  const scoredRun = () =>
    contentFitnessHeadline(props.data).score === null
      ? null
      : props.data.lastRun;
  const latestAttempt = () => props.data.latestAttempt;
  const coverage = () => scanCoverage(props.data, props.completedRun);
  const hasLaterAttempt = () =>
    Boolean(
      latestAttempt() && scoredRun() && latestAttempt()?.id !== scoredRun()?.id,
    );

  return (
    <div class="signal-score-provenance">
      <strong>
        {scoredRun()
          ? `Latest completed scored run / ${relativeAge(scoredRun()?.finishedAt ?? null)}`
          : "No completed scored run"}
      </strong>
      <span>{scanCoverageLine(coverage())}</span>
      <Show when={hasLaterAttempt()}>
        <small class="is-warning">
          Latest scan attempt{" "}
          {attemptStatus(latestAttempt()?.status ?? "failed")} /{" "}
          {relativeAge(latestAttempt()?.finishedAt ?? null)}. The score remains
          from the completed run above.
        </small>
      </Show>
    </div>
  );
}

function attemptStatus(value: string): string {
  return spacedKey(value);
}
